module.exports = __webpack_public_path__ + "img/download_qrcode.8152b61c.jpeg";